import React from 'react';
import cn from 'classnames';
import s from './DetailsRightSide.scss';
const DetailsRightSide = ({ firstRow, secondRow, firstRowClassName, secondRowClassName })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['first-row'], firstRowClassName)
    }, firstRow), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['second-row'], secondRowClassName)
    }, secondRow));
};
DetailsRightSide.displayName = 'DetailsRightSide';
export default DetailsRightSide;

//# sourceMappingURL=DetailsRightSide.js.map